export function variantSupportsDescription(variant) {
    return variant === 'container' || variant === 'default' || variant === 'footer';
}
//# sourceMappingURL=utils.js.map